import * as ReactDOM from 'react-dom';
import { OWA_AUTO_LINKS_CLASSNAME, X_OWA_AUTO_LINKS_CLASSNAME } from 'owa-attachment-link-common';

export function removeReactContent(entityElement: HTMLElement) {
    let beautifulLinks = entityElement.querySelectorAll('.' + OWA_AUTO_LINKS_CLASSNAME);
    if (beautifulLinks?.[0]?.parentElement) {
        ReactDOM.unmountComponentAtNode(beautifulLinks[0].parentElement);
    } else {
        // These are beatiful links from forward/resuming draft
        beautifulLinks = entityElement.querySelectorAll('.' + X_OWA_AUTO_LINKS_CLASSNAME);
        if (beautifulLinks?.[0]?.parentElement) {
            ReactDOM.unmountComponentAtNode(beautifulLinks[0].parentElement);
        }
    }

    const containerElement = entityElement.querySelectorAll('[data-fluid-container]')[0];
    if (containerElement) {
        ReactDOM.unmountComponentAtNode(containerElement);
    }
}
